// ====================================================================================
// scrollytelling.module.js
// ====================================================================================
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  A11y,
  Keyboard,
  EffectFade,
  EffectCreative,
  Parallax,
  Thumbs,
} from "swiper/modules";

import ScrollyTellingVideoSlide from "./CE/scrollytellingVideoSlide.js";

const baseModules = [Navigation, Pagination, A11y, Keyboard, Thumbs];
const pages = document.querySelectorAll(".scrollytelling-page");
const nav = document.querySelector(".scrolly-nav-inner");
const navBar = document.querySelector(".scrolly-nav-bar");
const outerSlider = document.querySelector(".scrolly-pages");
const innerSliders = document.querySelectorAll(".scrolly-content");
const header = document.querySelector(".page-header");
const footer = document.querySelector(".page-footer");

const pagination = {
  headerHeight: 0,
  footerHeight: 0,
  complete: false,
  activePage: null,
  activeSliderId: null,
  progresses: {},
  items: {},
  list: [],
};

const sliders = {
  outer: null,
  oList: {},
  iList: {},
};

const getParent = (el, selector) => {
  let parent = el;
  while (!parent.classList.contains(selector)) {
    parent = parent.parentElement;
  }
  return parent;
};

const fixTextPosition = (swiper) => {
  if (swiper.slides.length < 1) return;
  let activeId = swiper.slides[swiper.activeIndex].id;
  let activeSlide = document.getElementById(activeId);
  let activeText = activeSlide.querySelector(".text");
  if (!activeText) return;
  let cssTop = parseFloat(activeText.dataset.top);
  activeText.style.top = cssTop + "%";
};

const fixTextPosition2 = (id) => {
  if (!id) return;
  let activeSlide = document.getElementById(id);
  let activeText = activeSlide.querySelector(".text");
  if (!activeText) return;
  let cssTop = parseFloat(activeText.dataset.top);
  activeText.style.top = cssTop + "%";
};

const updateProgressBar = () => {
  let el = document.getElementById(`b-${pagination.activePage}`);
  // if (!el) {
  //   el = document.getElementById(`b-${pagination.activeSliderId}`);
  // }
  if (!el) return;
  let bounds = el.getBoundingClientRect();
  // let factor = pagination.progresses[pagination.activeSliderId];
  let navBounds = nav.getBoundingClientRect();

  let progressWidth = bounds.width / 2;
  let progress = bounds.left - navBounds.left + progressWidth;
  if (pagination.complete) {
    navBar.style.width = `100%`;
  } else {
    navBar.style.width = `${progress}px`;
  }
};

const updateNavIndex = (swiper) => {
  let index = swiper.activeIndex;
  let activeId = swiper.slides[swiper.activeIndex].id;
  let sliderId = null;

  // if (swiper.el.classList.contains("scrollytelling-page")) {
  //   sliderId = swiper.el.parentElement.id;
  //   pagination.progresses[sliderId] = swiper.progress;
  //   pagination.activeSliderId = sliderId;
  // } else if (swiper.el.classList.contains("scrolly-pages")) {
  //   pagination.activeSliderId = swiper.slides[swiper.activeIndex].id;
  // } else if (swiper.el.classList.contains("scrolly-content")) {
  //   sliderId = swiper.el.parentElement.id;
  //   pagination.activeSliderId = sliderId;
  //   pagination.progresses[sliderId] = swiper.progress;
  // }

  let button = nav.querySelector(`button[data-index="${index}"]`);
  if (button) {
    nav.querySelectorAll(".nav-button").forEach((btn) => {
      btn.classList.remove("active");
      btn.classList.remove("before");
      btn.classList.remove("after");
    });
    let prev = button.previousElementSibling;
    if (prev) prev.classList.add("before");
    let next = button.nextElementSibling;
    if (next) next.classList.add("after");
    button.classList.add("active");
  }
  pagination.activePage = activeId;
  updateProgressBar();
  setTimeout(() => updateProgressBar(), 400);
};

const getEffect = (layout) => {
  let data = {
    modules: [...baseModules],
    effect: "slide",
  };
  switch (layout) {
    case "0": // Überblenden
      data.modules.push(EffectFade);
      data.effect = "fade";
      break;
    case "1": // Nach oben schieben
      data.modules.push(EffectCreative);
      data.effect = "creative";
      data.creativeEffect = {
        prev: { translate: [0, "-100%", 0] },
        next: { translate: [0, "100%", 0] },
      };
      break;
    case "2": // Nach unten schieben
      data.modules.push(EffectCreative);
      data.effect = "creative";
      data.creativeEffect = {
        prev: { translate: [0, "100%", 0] },
        next: { translate: [0, "-100%", 0] },
      };
      break;
    case "3": // Nach links schieben
      data.modules.push(EffectCreative);
      data.effect = "creative";
      data.creativeEffect = {
        prev: { translate: ["-100%", 0, 0] },
        next: { translate: ["100%", 0, 0] },
      };
      break;
    case "4": // Nach rechts schieben
      data.modules.push(EffectCreative);
      data.effect = "creative";
      data.creativeEffect = {
        prev: { translate: ["100%", 0, 0] },
        next: { translate: ["-100%", 0, 0] },
      };
      break;
    case "5": // Aufdecken
      data.modules.push(EffectCreative);
      data.effect = "creative";
      data.creativeEffect = {
        prev: { translate: ["100%", 0, 0] },
        next: {
          shadow: true,
          translate: [0, 0, -400],
        },
      };
      break;
    case "6": // Parallax
      data.modules.push(Parallax);
      data.speed = 600;
      data.parallax = true;
      break;
    default:
      break;
  }

  return data;
};

const addListenerMulti = (el, s, fn) => {
  s.split(" ").forEach((e) => el.addEventListener(e, fn, false));
};

let changeTimeout = null;

const changeSlide = (pSlide, direction) => {
  // add timeout to prevent multiple changes

  if (changeTimeout) clearTimeout(changeTimeout);

  changeTimeout = setTimeout(() => {
    const stopTime = 800;
    let oSlider = sliders.oList[sliders.outer];
    let iSlider = sliders.iList[pSlide.parentElement.parentElement.id];

    if (pSlide.id === "" && iSlider.el.classList.contains("video-swiper")) {
      let parent = getParent(
        pSlide.parentElement,
        "ctype-ce_scrollytelling_video"
      );

      if (
        (iSlider.isBeginning && direction === "prev") ||
        (iSlider.isEnd && direction === "next")
      ) {
        pSlide = parent;
        iSlider = sliders.iList[pSlide.parentElement.parentElement.id];
      }
    }

    pagination.items[pSlide.id] = true;
    setTimeout(() => (pagination.items[pSlide.id] = false), stopTime);
    setTimeout(() => fixTextPosition2(pSlide.id), 500);

    if (direction === "next") {
      let nextSlideId = pagination.list[pagination.list.indexOf(pSlide.id) + 1];

      if (nextSlideId && !pagination.items[nextSlideId]) {
        pagination.items[nextSlideId] = true;
        setTimeout(() => (pagination.items[nextSlideId] = false), stopTime);

        if (
          pagination.list.indexOf(nextSlideId) ===
          pagination.list.length - 1
        ) {
          pagination.complete = true;
          updateProgressBar(iSlider);
          setTimeout(() => updateProgressBar(iSlider), 400);
        }
      }
      setTimeout(() => iSlider.slideNext(), 100);
      if (iSlider.isEnd) {
        // let nextParent = oSlider.slides[oSlider.activeIndex + 1].id;
        // pagination.progresses[nextParent] = 0;
        setTimeout(() => oSlider.slideNext(), 100);
      }
    }

    if (direction === "prev") {
      let prevSlideId = pagination.list[pagination.list.indexOf(pSlide.id) - 1];

      if (prevSlideId && !pagination.items[prevSlideId]) {
        pagination.items[prevSlideId] = true;
        setTimeout(() => (pagination.items[prevSlideId] = false), stopTime);

        if (pagination.list.indexOf(prevSlideId) < pagination.list.length - 1) {
          pagination.complete = false;
          updateProgressBar(iSlider);
          setTimeout(() => updateProgressBar(iSlider), 400);
        }
      }
      setTimeout(() => iSlider.slidePrev(), 100);
      if (iSlider.isBeginning) {
        // let prevParent = oSlider.slides[oSlider.activeIndex - 1].id;
        // pagination.progresses[prevParent] = 1;
        setTimeout(() => oSlider.slidePrev(), 100);
      }
    }
  }, 50);
};

const initWheelEvent = (pSlide) => {
  let lastTouchPos = null;
  let lastTouchTimeout = null;

  addListenerMulti(pSlide, "wheel touchmove", (e) => {
    if (e.type === "touchmove") {
      if (lastTouchTimeout) {
        clearTimeout(lastTouchTimeout);
        e.deltaY = lastTouchPos - e.touches[0].clientY;
        lastTouchPos = e.touches[0].clientY;
        if (e.deltaY > 3) e.deltaY = 3;
        if (e.deltaY < -3) e.deltaY = -3;
      } else {
        lastTouchPos = e.touches[0].clientY;
      }

      lastTouchTimeout = setTimeout(() => (lastTouchPos = null), 100);
    }

    let iSlider = sliders.iList[pSlide.parentElement.parentElement.id];

    if (iSlider.animating) return;
    if (pagination.items[pSlide.id]) return;

    let text = pSlide.querySelector(".text");

    if (text) {
      let textPos = text.getBoundingClientRect();
      let upperBound = pagination.headerHeight;
      let lowerBound = window.innerHeight - pagination.footerHeight;
      let top = 0;
      let bottom = 0;
      let cssTop = parseInt(text.style.top.replace("%", ""));

      top = textPos.top - upperBound;
      bottom = lowerBound - textPos.bottom;

      if (top < 0 && bottom - 100 > 0 && e.deltaY > 0) {
        changeSlide(pSlide, "next");
      }

      if (bottom < 0 && top - 100 > 0 && e.deltaY < 0) {
        changeSlide(pSlide, "prev");
      }

      let delta = e.deltaY;
      if (delta > 6) delta = 6;
      if (delta < -6) delta = -6;
      cssTop = cssTop - delta;

      text.style.top = cssTop + "%";
    } else {
      if (e.deltaY > 0) changeSlide(pSlide, "next");
      if (e.deltaY < 0) changeSlide(pSlide, "prev");
    }
  });
};

// ====================================================================================
// Init
// ====================================================================================

export const init = function () {
  let outerEffect = getEffect(outerSlider.dataset.effect);
  let outerId = outerSlider.id;

  sliders.outer = outerId;
  sliders.oList[outerId] = new Swiper(`#${outerId}`, {
    ...outerEffect,
    direction: "horizontal",
    a11y: true,
    keyboard: true,
    watchSlidesProgress: true,
    navigation: {
      enabled: true,
      nextEl: ".scrolly-nav-next",
      prevEl: ".scrolly-nav-prev",
    },
    on: {
      init: function (swiper) {
        setTimeout(() => {
          updateNavIndex(swiper);
        }, 500);
      },
      slideChange: function (swiper) {
        updateNavIndex(swiper);
      },
    },
  });

  innerSliders.forEach((innerSlider) => {
    let innerId = innerSlider.id;
    let innerEffect = getEffect(innerSlider.dataset.effect);

    // let parentId = innerSlider.parentElement.id;
    // pagination.progresses[parentId] = 0;

    innerSlider
      .querySelectorAll(".ctype-ce_scrollytelling_video")
      .forEach((videoContainer) => {
        let videoSlider = videoContainer.querySelector(".video-swiper");
        let thumbSlider = videoContainer.querySelector(".scrolly-thumbs");
        let thumbId = null;

        if (thumbSlider) {
          thumbId = thumbSlider.id;
          sliders.iList[thumbId] = new Swiper(`#${thumbId}`, {
            slidesPerView: 1,
            spaceBetween: 0,
            a11y: true,
            keyboard: true,
            watchSlidesProgress: true,
            breakpoints: {
              540: {
                slidesPerView: 2,
                spaceBetween: 32,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 32,
              },
            },
            on: {
              init: function (swiper) {
                if (swiper.slides.length > swiper.visibleSlides.length) {
                  videoContainer.classList.add("scrolly-thumbs--active");
                } else {
                  videoContainer.classList.remove("scrolly-thumbs--active");
                }
              },
              resize: function (swiper) {
                if (swiper.slides.length > swiper.visibleSlides.length) {
                  videoContainer.classList.add("scrolly-thumbs--active");
                } else {
                  videoContainer.classList.remove("scrolly-thumbs--active");
                }
              },
            },
          });
        }

        if (videoSlider) {
          let videoId = videoSlider.id;
          let videoEffect = getEffect(videoSlider.dataset.effect);

          sliders.iList[videoId] = new Swiper(`#${videoId}`, {
            ...videoEffect,
            a11y: true,
            keyboard: true,
            watchSlidesProgress: true,
            navigation: {
              nextEl: `#${videoContainer.id} .swiper-button-next`,
              prevEl: `#${videoContainer.id} .swiper-button-prev`,
            },
            thumbs: {
              swiper: sliders.iList[thumbId],
            },
            on: {
              init: (swiper) =>
                ScrollyTellingVideoSlide.init(innerSlider, swiper),
              slideChange: (swiper) =>
                ScrollyTellingVideoSlide.slideChange(swiper),
              beforeSlideChangeStart: (swiper) =>
                ScrollyTellingVideoSlide.beforeSlideChange(swiper),
            },
          });
        }

        let hideBtn = videoContainer.querySelector(".video-nav-hide");
        if (hideBtn) {
          hideBtn.addEventListener("click", () => {
            if (videoContainer.classList.contains("video-nav-hidden")) {
              videoContainer.classList.remove("video-nav-hidden");
              hideBtn.querySelector(".text").innerHTML = "ausblenden";
            } else {
              videoContainer.classList.add("video-nav-hidden");
              hideBtn.querySelector(".text").innerHTML = "einblenden";
            }
          });
        }
      });

    sliders.iList[innerId] = new Swiper(`#${innerId}`, {
      ...innerEffect,
      // direction: "vertical",
      a11y: true,
      keyboard: true,
      navigation: false,
      pagination: {
        el: `#${innerId} .swiper-pagination`,
        type: "fraction",
      },
      watchSlidesProgress: true,
      on: {
        init: (swiper) => {
          fixTextPosition(swiper);
          // updateNavIndex(swiper);
        },
        // slideChange: (swiper) => updateNavIndex(swiper),
        slideChangeTransitionStart: (swiper) => fixTextPosition(swiper),
      },
    });
  });

  // populate navigation
  pages.forEach((page, index) => {
    let title = page.dataset.title;
    let pSlides = page.querySelectorAll(".swiper-slide");

    let button = document.createElement("button");
    button.innerHTML = title;
    button.id = `b-${page.id}`;
    button.classList.add("nav-button");
    button.setAttribute("data-index", index);
    nav.appendChild(button);

    pSlides.forEach((pSlide, i) => {
      pagination.items[pSlide.id] = false;
      pagination.list.push(pSlide.id);
      initWheelEvent(pSlide);
    });

    button.addEventListener("click", () => {
      let slider = sliders.oList[sliders.outer];
      slider.slideTo(index);
    });
  });

  const updateSliderHeight = () => {
    let notSliderHeight = 0;
    if (header) notSliderHeight += header.offsetHeight;
    if (footer) notSliderHeight += footer.offsetHeight;
    // if (nav) notSliderHeight += nav.offsetHeight;
    pagination.headerHeight = header.offsetHeight;
    // pagination.footerHeight = footer.offsetHeight + nav.offsetHeight;
    pagination.footerHeight = footer.offsetHeight;
    let maxSliderHeight = window.innerHeight - notSliderHeight - 5;
    outerSlider.style.height = maxSliderHeight + "px";
  };
  updateSliderHeight();
  setTimeout(() => updateSliderHeight(), 5000);

  let attempts = 0;
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      window.addEventListener("resize", function (e) {
        updateSliderHeight();
        updateProgressBar();
        setTimeout(() => updateProgressBar(), 400);
      });
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
